import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SSRSafeElement from 'commons/SSRSafeElement';
import Link from 'components/consumer/Link';
import useKeyboardControlForDropdown from 'hooks/useKeyboardControlForDropdown';
import IconInspirationUnderline from 'components/icons/IconInspirationUnderline';
const DesktopNavCategoryItem = t0 => {
  const $ = _c(39);
  const {
    containerRef,
    color: t1,
    id,
    label,
    isOpen,
    setIsLinkHovered,
    url
  } = t0;
  const color = t1 === undefined ? "content" : t1;
  const toggleRef = useRef(null);
  let t2;
  if ($[0] !== id) {
    t2 = () => document.getElementById(`DesktopNavCategory--${id}`);
    $[0] = id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] !== id || $[3] !== setIsLinkHovered) {
    t3 = () => {
      setIsLinkHovered(id, true);
    };
    t4 = () => {
      setIsLinkHovered(id, false);
    };
    $[2] = id;
    $[3] = setIsLinkHovered;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== containerRef || $[7] !== isOpen || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      isOpen,
      isParentPopup: true,
      getPopupContainerElement: t2,
      toggleContainerRef: containerRef,
      toggleRef,
      open: t3,
      close: t4
    };
    $[6] = containerRef;
    $[7] = isOpen;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useKeyboardControlForDropdown(t5);
  const isColorRed = color === "red";
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = classNames("group/DesktopNavCategoryItem-link text-sm font-bold inline-block min-h-[55px] px-2 py-0 relative no-underline", "xl:text-base xl:font-bold", "focus-visible:outline-offset-[-2px]");
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  let t8;
  if ($[13] !== id || $[14] !== setIsLinkHovered) {
    t7 = () => {
      setIsLinkHovered(id, true);
    };
    t8 = () => {
      setIsLinkHovered(id, false);
    };
    $[13] = id;
    $[14] = setIsLinkHovered;
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  const t9 = !isColorRed;
  const t10 = isOpen && !isColorRed;
  const t11 = !isColorRed;
  const t12 = !isColorRed;
  const t13 = isOpen && isColorRed;
  let t14;
  if ($[17] !== isColorRed || $[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t13 || $[22] !== t9) {
    t14 = classNames("items-center [border-bottom:1px_solid_#fff] inline-flex min-h-[55px] text-center", {
      "text-gray": t9,
      "[border-bottom:1px_solid_#107c8c]": t10,
      "group-focus-visible/DesktopNavCategoryItem-link:[border-bottom:1px_solid_#107c8c] group-focus-visible/DesktopNavCategoryItem-link:text-brand": t11,
      "group-hover/DesktopNavCategoryItem-link:[border-bottom:1px_solid_#107c8c] group-hover/DesktopNavCategoryItem-link:text-brand": t12,
      "text-red": isColorRed,
      "[border-bottom:1px_solid_#b85455]": t13,
      "group-focus-visible/DesktopNavCategoryItem-link:[border-bottom:1px_solid_#b85455] group-focus-visible/DesktopNavCategoryItem-link:text-red": isColorRed,
      "group-hover/DesktopNavCategoryItem-link:[border-bottom:1px_solid_#b85455] group-hover/DesktopNavCategoryItem-link:text-red": isColorRed
    });
    $[17] = isColorRed;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== label || $[25] !== t14) {
    t15 = <span className={t14}>{label}</span>;
    $[24] = label;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== id) {
    t16 = id === "inspiration" && <IconInspirationUnderline className="left-[7px] absolute top-10 w-[72px]" />;
    $[27] = id;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== id || $[30] !== t15 || $[31] !== t16 || $[32] !== t7 || $[33] !== t8 || $[34] !== url) {
    t17 = <Link to={url} className={t6} onMouseEnter={t7} onMouseLeave={t8} data-xc={id} ref={toggleRef}>{t15}{t16}</Link>;
    $[29] = id;
    $[30] = t15;
    $[31] = t16;
    $[32] = t7;
    $[33] = t8;
    $[34] = url;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== id || $[37] !== t17) {
    t18 = <li key={id} className="list-none">{t17}</li>;
    $[36] = id;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
};
DesktopNavCategoryItem.propTypes = {
  color: PropTypes.oneOf(['content', 'red']),
  containerRef: PropTypes.shape({
    current: PropTypes.instanceOf(SSRSafeElement)
  }),
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  label: PropTypes.string,
  url: PropTypes.string,
  setIsLinkHovered: PropTypes.func
};
export default DesktopNavCategoryItem;